import React, { useEffect } from 'react';
import { Row, Col, Form, Select, Button, Input } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { getPerformance, ChangePerformance } from 'store/auth/profile/profileSlice';
import { useDispatch, useSelector } from 'react-redux';

export const PerformanceForm = ({ setShowModal }) => {
  const dispatch = useDispatch();
  const performance = useSelector((state) => state.Profile.performance);
  const [form] = Form.useForm();


  useEffect(() => {
    dispatch(getPerformance());
  }, [dispatch]);

  // Populate form with existing data when performance data changes
  useEffect(() => {
    if (performance && performance?.performances?.length > 0) {
      const currentPerformance = performance?.performances?.[0];

      // Important: For Form.List to work properly, we need to initialize it correctly
      form.setFieldsValue({
        // These arrays need to be set directly for Form.List to display them
        trophies: currentPerformance.trophies,
        individualTitles: currentPerformance.individualTitles,

        // Statistics fields
        goalsScored: currentPerformance.statistics?.goalsScored?.toString() || '0',
        assists: currentPerformance.statistics?.assists?.toString() || '0',
        cardsReceived: currentPerformance.statistics?.cardsReceived?.toString() || '0',
        minutesPlayed: currentPerformance.statistics?.minutesPlayed?.toString() || '0',
      });
    }
  }, [performance, form]);

  const trophiesOptions = [
    "Algerian Cup",
    "Champions League",
    "CAF Cup",
    "Ligue 1 Mobilis",
    "Arab Cup",
    "Friendly Matches",
    "National Talent Tournament",
    "Regional League Cup",
  ];
  const onFinish = async (values) => {
    const formData = {
      trophies: values.trophies || [],
      individualTitles: values.individualTitles || [],
      statistics: {

        goalsScored: values.goalsScored || 0,
        assists: values.assists || 0,
        cardsReceived: values.cardsReceived || 0,
        minutesPlayed: values.minutesPlayed || 0,
      }
    }
    try {
      const response = await dispatch(ChangePerformance(formData))
      dispatch(getPerformance());
      setShowModal(false)
      console.log(response)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Row gutter={16} className="mt-5" style={{ marginBottom: '20px' }}>
        <Col xs={24} sm={12} md={12} lg={12}>
          <Form.List name="trophies">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Form.Item
                    {...restField}
                    key={key}
                    name={name}
                    label={name === 0 ? "Trophées remportés" : ""}
                    rules={[
                      { required: true, message: "Veuillez sélectionner un trophée" },
                    ]}
                  >
                    <div style={{ display: "flex", gap: "10px" }}>
                      <Select
                        placeholder="Sélectionner un trophée"
                        options={trophiesOptions.map((trophy) => ({
                          label: trophy,
                          value: trophy,
                        }))}
                        style={{ flex: 1 }}
                        value={form.getFieldValue(["trophies", name])} // Ensure it has a controlled value
                        onChange={(value) => form.setFieldsValue({ trophies: { ...form.getFieldValue("trophies"), [name]: value } })} // Update value
                      />
                      <Button
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => remove(name)}
                      />
                    </div>
                  </Form.Item>
                ))}
                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                  Ajouter un trophée
                </Button>
              </>
            )}
          </Form.List>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12}>
          <Form.List name="individualTitles">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Form.Item
                    {...restField}
                    key={key}
                    name={name}
                    label={name === 0 ? "Titres individuels" : ""}
                  >
                    <div style={{ display: "flex", gap: "10px" }}>
                      <Select
                        placeholder='selectioner un titre'
                        style={{ flex: 1 }}
                        value={form.getFieldValue(["individualTitles", name])} // Ensure controlled value
                        onChange={(value) => form.setFieldsValue({ individualTitles: { ...form.getFieldValue("individualTitles"), [name]: value } })} // Update value
                      >
                        <Select.Option value="Top Scorer">Top Scorer</Select.Option>
                        <Select.Option value="Man of the Match">Man of the Match</Select.Option>
                        <Select.Option value="Best Player">Best Player</Select.Option>
                      </Select>
                      <Button
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => remove(name)}
                      />
                    </div>
                  </Form.Item>
                ))}
                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                  Ajouter un titre
                </Button>
              </>
            )}
          </Form.List>
        </Col>
      </Row>
      <div className="d-flex justify-content-center p-3 ">
        <h3> Statistiques clés </h3>
      </div>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="goalsScored"
          >
            <Input placeholder="Nombre de buts marqués " />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="assists"
          >
            <Input placeholder='Passes décisives ' />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="cardsReceived"
          >
            <Input placeholder="Cartons reçus  " />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='minutesPlayed'
          >
            <Input placeholder='Minutes jouées' />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="end">
        <Col>
          <Button type="primary" htmlType="submit">
            Save Changes
          </Button>
        </Col>
      </Row>
    </Form>
  );
};